import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TriggerButton } from "widgets";

import type { TableQuerySpec } from "@/graphql.ts";
import { type IMutantGenome, setSelectedMutantGenomeList } from "@/redux/modules/genome-browser.ts";
import { getTableDataSlice } from "@/redux/modules/table-data.ts";
import type { IAppState } from "@/redux/reducer.ts";
import type { ReduxDispatch } from "@/redux/redux-utils.ts";

interface ISyncMutantGenomesButtonProps {
  tableSpec: TableQuerySpec;
}

export function SyncMutantGenomesButton(props: ISyncMutantGenomesButtonProps) {
  const dispatch = useDispatch<ReduxDispatch>();
  const sortedGenomeIds: number[] = useSelector<IAppState, number[]>(
    (state) => getTableDataSlice(state.tableData, props.tableSpec)?.rowIds,
  );
  const selectedMutantGenomes = useSelector<IAppState, IMutantGenome[]>(
    (state) => state.genomeBrowser.selectedMutantGenomes,
  );

  const syncMutantGenomesToVariantsTrack = useCallback(() => {
    const reorderedMutantGenomes = selectedMutantGenomes
      .filter((genome) => sortedGenomeIds.includes(genome.id))
      .map((genome) => genome.id) // work on list of ids
      .sort((a, b) => sortedGenomeIds.indexOf(a) - sortedGenomeIds.indexOf(b))
      .map((id) => selectedMutantGenomes.find((genome) => genome.id === id)); // map it back to real mutant genomes
    dispatch(setSelectedMutantGenomeList(reorderedMutantGenomes));
  }, [sortedGenomeIds, selectedMutantGenomes]);

  return (
    <TriggerButton
      icon={"sync"}
      label={"Genome Sync"}
      onPress={syncMutantGenomesToVariantsTrack}
      tooltip={"Apply the sorting to the genomes in the variants track"}
      showLabel
    />
  );
}
